import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FoodcourtmenuService } from 'src/app/services/foodcourtmenu.service';

@Component({
  standalone: false,
  selector: 'app-remove-modal-menu',
  templateUrl: './remove-modal-menu.component.html',
  styleUrls: ['./remove-modal-menu.component.scss'],
})
export class RemovemodalmenuComponent implements OnInit {
  @Input() menuId: string;
  @Input() fromDetailsPage: any;
  @Input() fromListPage: any;
  @Input() foodCourtVendorId: any;

  listCouponIds = [];

  myForm!: FormGroup;

  constructor(
    public modal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private router: Router,
    private foodcourtmenuService: FoodcourtmenuService
  ) {
    this.myForm = this.formBuilder.group({
      deletedBy: '',
      userId: ''
    });
  }

  ngOnInit(): void { }

  deleteVendorData() {
    let vendorId = localStorage.getItem('vendor_id');
    // let option = {
    //   "foodCourtVendorMenuIds": this.menuId
    // };
    this.listCouponIds = [];
    if (this.fromDetailsPage == 'yes') {
      this.foodcourtmenuService
        .removeMenuBulk(this.menuId)
        .subscribe((res) => {
          console.log(res);
          if (res.isValid) {
            this.router.navigate(['/list-food-menu/' + vendorId]);
          }
        });
    }
    if (this.fromDetailsPage == 'no') {
      this.foodcourtmenuService
        .removeMenuBulk(this.menuId)
        .subscribe((res) => {
          console.log(res);
          if (res.isValid) {
            location.reload();
          }
        });
    }
    this.modal.dismiss();
  }
}
